
import { number_to_price } from '../../../../helper/common'
import { RightOutlined, DownOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { checkDurationUsageDate } from '../../../../components/FeaturesComponent/automatedTrafficFineNotificationServiceCard'
import './index.scss'
import { IS_TAX_CDS_MODE, CURRENT_APP_MODE_CONFIG } from '../../../../constants/appMode'

export default function AutomatedTrafficFineNotificationPaymentInfo({
  vehicles = [],
  services = [],
  subTotalAmount = 0,
  taxAmount = 0,
  discountAmount = 0,
  usageDate,
  totalAmount = 0
}) {
  const [showAllVehicles, setShowAllVehicles] = useState(false)

  const displayedVehicles = showAllVehicles ? vehicles : vehicles.slice(0, 1)
  const vehicleInfoLabel = CURRENT_APP_MODE_CONFIG.paymentInfoLabel

const getVehicleDisplayValue = (vehicle) => {
  if (typeof vehicle === 'string') return vehicle

  if (IS_TAX_CDS_MODE) {
    const taxIdentity =
      vehicle?.taxCode ||
      vehicle?.citizenIdentityNumber ||
      vehicle?.plate ||
      '-'

    const taxpayerName = vehicle?.taxpayerName || ''

    const address =
      vehicle?.businessAddress ||
      vehicle?.taxRegistrationAddress ||
      ''

    return (
      <div className="tax-payment-info">
        <div className="tax-payment-info__main">{taxIdentity}</div>
        {taxpayerName && (
          <div className="tax-payment-info__main">{taxpayerName}</div>
        )}
        {address && (
          <div className="tax-payment-info__address">{address}</div>
        )}
      </div>
    )
  }

  return vehicle?.plate || '-'
}

  return (
    <div className="AutomatedTrafficFineNotificationPaymentInfo">
      <div className="AutomatedTrafficFineNotificationPaymentInfo_item">
        <div className="AutomatedTrafficFineNotificationPaymentInfo_title">Thông tin giao dịch</div>
        {/* Thông tin dịch vụ */}
        {services.map((service, index) => (
          <div key={index} className="AutomatedTrafficFineNotificationPaymentInfo_content">
            <div className="content_lable">Gói dịch vụ {services.length > 1 ? `(${index + 1})` : ''}</div>
            <div className="content_value">{service?.productName || '-'}</div>
          </div>
        ))}

        {/* Thông tin xe */}
        {displayedVehicles.map((vehicle, index) => (
          <div
            key={index}
            className={`AutomatedTrafficFineNotificationPaymentInfo_content ${
              IS_TAX_CDS_MODE ? 'AutomatedTrafficFineNotificationPaymentInfo_content--tax' : ''
            }`}
          >
           <div className="content_lable">
            {vehicleInfoLabel} {vehicles.length > 1 && (showAllVehicles || index > 0) ? `(${index + 1})` : ''}
          </div>
           <div
            className={`content_value ${IS_TAX_CDS_MODE ? 'content_value--tax' : ''}`}
            style={{
              display: 'flex',
              justifyContent: IS_TAX_CDS_MODE ? 'flex-start' : 'space-between',
              alignItems: 'flex-start'
            }}
          >
            <div className={IS_TAX_CDS_MODE ? 'content_value_tax' : ''}>
              {getVehicleDisplayValue(vehicle)}
            </div>
              {vehicles.length > 1 &&
                index === 0 &&
                (showAllVehicles ? (
                  <DownOutlined style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => setShowAllVehicles(false)} />
                ) : (
                  <RightOutlined style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => setShowAllVehicles(true)} />
                ))}
            </div>
          </div>
        ))}

        <div className="AutomatedTrafficFineNotificationPaymentInfo_content">
          <div className="content_lable">Thời hạn</div>
          <div className="content_value">{checkDurationUsageDate(usageDate)}</div>
        </div>
      </div>
      <div className="AutomatedTrafficFineNotificationPaymentInfo_item">
        <div className="AutomatedTrafficFineNotificationPaymentInfo_title">Số tiền giao dịch</div>
        <div className="AutomatedTrafficFineNotificationPaymentInfo_content">
          <div className="content_lable">Số tiền</div>
          <div className="content_value">{number_to_price(subTotalAmount)}đ</div>
        </div>
        <div className="AutomatedTrafficFineNotificationPaymentInfo_content">
          <div className="content_lable">Thuế VAT (10%)</div>
          <div className="content_value">{number_to_price(taxAmount)}đ</div>
        </div>
        <div className="AutomatedTrafficFineNotificationPaymentInfo_note">Vui lòng liên hệ CSKH nếu cần xuất Hoá đơn GTGT.</div>
        <div className="AutomatedTrafficFineNotificationPaymentInfo_content">
          <div className="content_lable">Tổng tiền thanh toán</div>
          <div className="content_value total-amount">{number_to_price(totalAmount)}đ</div>
        </div>
      </div>
    </div>
  )
}
